"use client"

import { Skeleton } from "@/components/ui/skeleton"

const FeaturedPostSkeleton = () => {
  return (
    <div className="flex flex-col lg:flex-row w-full">
      <Skeleton className="sm:h-[319px] h-[195px] sm:w-[65.95%] w-full rounded" />
      <div className="sm:w-[34.05%] w-full flex flex-col sm:p-4 p-2 gap-2 bg-[#f5f5f5]">
        <Skeleton className="h-6 w-full rounded" />
        <Skeleton className="h-4 w-full rounded" />
        <Skeleton className="h-4 w-5/6 rounded" />
        <Skeleton className="h-4 w-3/4 rounded mt-2" />
      </div>
    </div>
  )
}

export default FeaturedPostSkeleton
